import type { TourDefinition } from '../tours.types';


export const FIRST_ADD_CERTIFICATE_TOUR: TourDefinition = {
  id: 'first_add_certificate',
  route: '/perfil/perfil',
  remember: true,
  steps: [
    {
      element: '[data-tour="perfil-groups-column"]',
      popover: {
        title: 'Asociarte a grupos',
        description:
          'También puedes asociar tus certificados a grupos dentro de tu empresa para ser incluido en procesos de firma grupales.',
          side: 'left',
        align: 'center',
      },
    }
  ],
};
